export class CustomError<T = unknown> extends Error {
  code: number;
  message: string;
  details?: T;

  constructor(message: string, code: number, details?: T) {
    super(message);
    this.code = code;
    this.message = message;
    this.details = details;
  }
}
